/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface BorrowerNaturalPersonDto
 */
export interface BorrowerNaturalPersonDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    civilityId: string;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerNaturalPersonDto
     */
    birthDate: Date;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    firstName: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof BorrowerNaturalPersonDto
     */
    address: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    birthName?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    birthCountryId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    taxResidenceCountryId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    nationalityId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerNaturalPersonDto
     */
    isPPE: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerNaturalPersonDto
     */
    isFPE: boolean;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    companyRole?: string;
    /**
     * Profession or job title
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    job: string;
    /**
     * Type of prospect (individual, company, etc.)
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    prospectTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerNaturalPersonDto
     */
    borrowerId?: string;
}

/**
 * Check if a given object implements the BorrowerNaturalPersonDto interface.
 */
export function instanceOfBorrowerNaturalPersonDto(value: object): value is BorrowerNaturalPersonDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('birthCountryId' in value) || value['birthCountryId'] === undefined) return false;
    if (!('taxResidenceCountryId' in value) || value['taxResidenceCountryId'] === undefined) return false;
    if (!('nationalityId' in value) || value['nationalityId'] === undefined) return false;
    if (!('isPPE' in value) || value['isPPE'] === undefined) return false;
    if (!('isFPE' in value) || value['isFPE'] === undefined) return false;
    if (!('job' in value) || value['job'] === undefined) return false;
    if (!('prospectTypeId' in value) || value['prospectTypeId'] === undefined) return false;
    return true;
}

export function BorrowerNaturalPersonDtoFromJSON(json: any): BorrowerNaturalPersonDto {
    return BorrowerNaturalPersonDtoFromJSONTyped(json, false);
}

export function BorrowerNaturalPersonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerNaturalPersonDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'] == null ? undefined : json['id'],
        'civilityId': json['civilityId'],
        'birthDate': (new Date(json['birthDate'])),
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'address': AddressDtoFromJSON(json['address']),
        'phone': json['phone'],
        'email': json['email'],
        'birthName': json['birthName'] == null ? undefined : json['birthName'],
        'birthCountryId': json['birthCountryId'],
        'taxResidenceCountryId': json['taxResidenceCountryId'],
        'nationalityId': json['nationalityId'],
        'isPPE': json['isPPE'],
        'isFPE': json['isFPE'],
        'companyRole': json['companyRole'] == null ? undefined : json['companyRole'],
        'job': json['job'],
        'prospectTypeId': json['prospectTypeId'],
        'borrowerId': json['borrowerId'] == null ? undefined : json['borrowerId'],
    };
}

export function BorrowerNaturalPersonDtoToJSON(json: any): BorrowerNaturalPersonDto {
    return BorrowerNaturalPersonDtoToJSONTyped(json, false);
}

export function BorrowerNaturalPersonDtoToJSONTyped(value?: BorrowerNaturalPersonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
        'civilityId': value['civilityId'],
        'birthDate': ((value['birthDate']).toISOString()),
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'address': AddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'email': value['email'],
        'birthName': value['birthName'],
        'birthCountryId': value['birthCountryId'],
        'taxResidenceCountryId': value['taxResidenceCountryId'],
        'nationalityId': value['nationalityId'],
        'isPPE': value['isPPE'],
        'isFPE': value['isFPE'],
        'companyRole': value['companyRole'],
        'job': value['job'],
        'prospectTypeId': value['prospectTypeId'],
        'borrowerId': value['borrowerId'],
    };
}

